var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-image-wrapper",class:{'odd-card': (_vm.idx + 2) % 2 === 0}},[_c('img',{staticClass:"feature-image",attrs:{"src":_vm.img,"alt":("feature_" + (_vm.idx + 1))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9bc80fe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LP/atoms/FeatureImage.vue
// module id = null
// module chunks = 